export default __webpack_public_path__ + "static/media/iconfacebook.571be710.png";